export const QUALITY_COLS = [
  'CU',
  'MO',
  'AU',
  'AG',
  'S',
  'ASCU',
  'VC',
  'DI',
  'GD',
  'QZ',
] as const;

export type QualityCol = (typeof QUALITY_COLS)[number];

export const FIXED_CSV_COLS = new Set([
  'NAME',
  'BLEND',
  'MATERIAL',
  'LOCATION',
  'INVENTORY',
  'SPECIFIC_GRAVITY',
]);

export const REQUIRED_CSV_COLS = ['NAME', 'MATERIAL', 'LOCATION'];

export const TEMPLATE_HEADERS = [
  'NAME',
  'BLEND',
  'MATERIAL',
  'LOCATION',
  'INVENTORY',
  'SPECIFIC_GRAVITY',
  ...QUALITY_COLS,
];

export const GRADE_TEMPLATE_SAMPLE_ROW: Record<string, string> = {
  NAME: 'GRADE_TEST_1',
  BLEND: 'B',
  MATERIAL: 'copper',
  LOCATION: 'Pit A',
  INVENTORY: '5000',
  SPECIFIC_GRAVITY: '2.7',
  CU: '0.45',
  MO: '0.005',
  AU: '0.004',
  AG: '0.592',
  S: '1.527',
  ASCU: '0.000',
  VC: '99.5',
  DI: '0',
  GD: '0',
  QZ: '0',
};

export const validateGradeHeaders = (
  fileHeaders: string[]
): { valid: boolean; missing: string[] } => {
  const upperHeaders = fileHeaders.map((h) => h.trim().toUpperCase());
  const missing = REQUIRED_CSV_COLS.filter((h) => !upperHeaders.includes(h));
  return { valid: missing.length === 0, missing };
};
